import React from 'react'
import { StackProps, useTheme, YStack } from 'tamagui'

import { getTextColorVar, TextColor } from '../utils/text'

type Props = {
  isSelected?: boolean
  href?: string
  target?: string
  selectedColor?: TextColor | 'cta'
} & StackProps

export default function SelectableCard({
  isSelected,
  children,
  href,
  target,
  selectedColor,
  ...stackProps
}: Props) {
  const theme = useTheme()
  const borderColor =
    selectedColor && selectedColor !== 'cta' ? getTextColorVar(selectedColor) : '$primaryText'
  return (
    <YStack borderRadius="$1" overflow="hidden">
      <YStack
        borderImage={
          isSelected && selectedColor === 'cta'
            ? `linear-gradient(${theme.red?.get()}, ${theme.amber?.get()}) 1`
            : undefined
        }
        borderWidth={1}
        borderStyle="solid"
        borderColor={isSelected && selectedColor !== 'cta' ? borderColor : '$hairline'}
        cursor="pointer"
        pressStyle={{
          borderImage:
            selectedColor === 'cta'
              ? `linear-gradient(${theme.red?.get()}, ${theme.amber?.get()}) 1`
              : undefined,
          borderColor: borderColor,
          backgroundColor: '$pressBg',
        }}
        hoverStyle={{ backgroundColor: '$hoverBg' }}
      >
        <YStack
          {...stackProps}
          tag={href ? 'a' : 'div'}
          href={href}
          target={target}
          padding="$2"
          backgroundColor="$translucentBg"
          style={{ textDecoration: 'none' }}
        >
          {children}
        </YStack>
      </YStack>
    </YStack>
  )
}
